<template>
  <v-dialog
    max-width="600"
    :value="value"
    :persistent="loading"
    :no-click-animation="loading"
    @input="$emit('input:dialog', $event)"
  >
    <v-card>
      <v-card-title class="headline">
        {{ $t('message.searcher.savedSearch.saveNewSearch') }}
      </v-card-title>
      <v-card-text>
        <v-text-field
          v-model="searchName"
          :label="$t('message.searcher.savedSearch.searchName')"
          required
          autofocus
          @keypress.enter="createSearch"
        ></v-text-field>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="secondary"
          flat
          :disabled="loading"
          @click="$emit('input:dialog', false)"
        >{{ $t('message.searcher.savedSearch.cancel') }}
        </v-btn>
        <v-btn color="secondary" flat :loading="loading" :disabled="hasErrors" @click="createSearch">
          {{ $t('message.searcher.savedSearch.save') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { cloneDeep } from 'lodash';

export default {
  name: 'nx-saved-searches-create-dialog',
  props: {
    value: Boolean,
    filters: {
      type: Object,
      required: true,
    },
    sort: {
      type: Object,
      required: true,
    },
    entity: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      searchName: '',
    };
  },
  computed: {
    hasErrors() {
      return this.searchName.trim() === '';
    },
  },
  watch: {
    value: {
      handler() {
        if (this.value) {
          this.searchName = '';
        }
      },
      immediate: true,
    },
  },
  methods: {
    async createSearch() {
      this.loading = true;
      const search = await this.$store.dispatch('searcher/SAVE_SEARCH', {
        name: this.searchName,
        searcher: this.entity,
        filters: cloneDeep(this.filters),
        sort: cloneDeep(this.sort),
      });
      this.loading = false;

      this.$emit('input', search);
      this.dismiss();
    },
    dismiss() {
      this.$emit('input:dialog', false);
    },
  },
};
</script>
